export enum BotIntegrationStatus {
  NotIntegrated = 'not_integrated',
  Pending = 'pending',
  Integrated = 'integrated',
}
